<template>
  <div class="duplicated">
    <Header propsTitle="회원가입"/>

    <div class="container">
      <div class="page-inner">
        <h1 class="step-title">
          이미 가입 된 <br />
          회원 정보가 있습니다.
        </h1>
        <p class="step-sub-title">
          아래의 휴대폰 번호가 맞으신가요?<br />
          <b>{{ userData.cell }}</b>
        </p>

        <div class="bottom-btn">
          <p class="mt-10">
            가입한 휴대폰 번호가 다르거나 가입한 적이 없는 경우 고객센터 1577-0000로
            문의 주세요
          </p>
          <v-btn color="primary" x-large depressed block rounded class="mb-3" @click="$emit('goLogin')">로그인</v-btn>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Header from "../../commonComp/WS-Header.vue";
export default {
  components: { Header },
  props: {
    userData: {
      type: Object,
    },
  },
  methods: {
    goTo() {
      this.$router.push({ path: "/login" }).catch(() => { });
    },
  },
};
</script>

<style lang="scss">
.duplicated {
  padding: 0;
  height: 100vh;
  overflow: hidden;

  .container {
    padding: 30px
  }

  .page-inner {
    text-align: center;
    position: relative;
    height: calc(100svh - 220px);
    padding: 1rem 0 0;
    margin: 0 auto 1rem;
  }

  .step-title {
    margin-top: 40px;
    font-size: 32px;

  }

  .step-sub-title {
    font-size: 16px;
    font-weight: 700;
    color: #414141;
    margin-top: 40px;

    b {
      color: #414141;
      font-size: 24px;
      font-weight: 500;
    }



  }


  .bottom-btn {
    position: absolute;
    width: 100%;
    bottom: 0;

    p {
      font-size: 16px;
      color: #414141;
      margin-top: 40px;
    }
  }

  .v-btn.btn-kakao {
    background: #f6d523;
    color: #000000;
  }
}
</style>
